import { Box, Button, CircularProgress, FormHelperText, Grid, Paper, Stack, TextField } from "@mui/material"
import React, { useEffect, useState } from "react"
import apiClient from "../../api/apiClient"
import { useOutletContext } from "react-router-dom"
const Settings = ({ role = "AD" }) => {
  const [load, setLoad] = useState(false)
  const [modalShow, setModalShow] = React.useState(false)
  const { setRefresh, user } = useOutletContext()
  // console.log(user,"lllll");
  let initialState = {
    sample_receive_days: "",
    est_date_exp: "",
    est_date_pp: "",
    est_date_regular: ""
  }
  const [formData, setFormData] = useState(initialState)
  // console.log(profile,"lllll");

  useEffect(() => {
    fetchSettings()
  }, [])

  const handleChange = (key, value) => {
    setFormData({ ...formData, [key]: value })
  }

  const fetchSettings = async () => {
    const result = await apiClient.get("/settings")
    if (!result.ok) {
      setFormData({
        sample_receive_days: 0,
        est_date_exp: 0,
        est_date_pp: 0,
        est_date_regular: 0
      })
      return
    }

    const responseData = result.data.result
    setFormData({
      sample_receive_days: responseData.sample_receive_days,
      est_date_pp: responseData.estimated_processing_days.pp_type,
      est_date_exp: responseData.estimated_processing_days.exp_type,
      est_date_regular: responseData.estimated_processing_days.regular
    })
  }

  const handleSubmit = async e => {
    setLoad(true)
    e.preventDefault()
    const formDataObj = {
      sample_receive_days: formData.sample_receive_days,
      estimated_processing_days: {
        pp_type: formData.est_date_pp,
        exp_type: formData.est_date_exp,
        regular: formData.est_date_regular
      }
    }
    const result = await apiClient.patch("/settings", formDataObj)
    setLoad(false)
    setRefresh(true)
    // console.log(result);
  }
  return (
    <Box sx={{ px: { xs: 2, md: 3 } }}>
      <Box sx={{ maxWidth: 980, mx: "auto" }}>
        <Box sx={{ mb: 3 }}>
          <h3 className="mb-1">App Global Settings</h3>
          <p className="mb-0 text-muted">Configure shared processing and notification timing for the app.</p>
        </Box>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #E5E7EB",
            borderRadius: 3,
            boxShadow: "0 16px 36px rgba(15, 23, 42, 0.08)",
            p: { xs: 2.5, md: 4 }
          }}
        >
          <form onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <Box>
                <h5 className="mb-1">Report Processing Dates</h5>
                <FormHelperText>
                  Enter processing days for each report type. Use 0 days to disable an estimate.
                </FormHelperText>
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <TextField
                      // required
                      label="Standard"
                      type="number" // Accepts only numbers
                      value={formData.est_date_regular}
                      onChange={e => handleChange("est_date_regular", e.target.value)}
                      variant="outlined"
                      fullWidth
                      // helperText="Enter the number of days . e.g 14 Days"
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                      // required
                      label="Expedite EXP"
                      type="number" // Accepts only numbers
                      value={formData.est_date_exp}
                      onChange={e => handleChange("est_date_exp", e.target.value)}
                      variant="outlined"
                      fullWidth
                      // helperText="Enter the number of days . e.g 14 Days"
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <TextField
                      // required
                      label="PP"
                      type="number" // Accepts only numbers
                      value={formData.est_date_pp}
                      onChange={e => handleChange("est_date_pp", e.target.value)}
                      variant="outlined"
                      fullWidth
                      // helperText="Enter the number of days . e.g 14 Days"
                    />
                </Grid>
              </Grid>

              <Box sx={{ borderTop: "1px solid #E5E7EB", pt: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      //  required
                      label="Sample Not-Received Date"
                      type="number" // Accepts only numbers
                      value={formData.sample_receive_days}
                      onChange={e => handleChange("sample_receive_days", e.target.value)}
                      variant="outlined"
                      fullWidth
                      // helperText="Enter the number of days . e.g 14 Days"
                    />
                    <FormHelperText>
                      Days before clients receive a sample-not-received email. Use 0 days to disable.
                    </FormHelperText>
                  </Grid>
                </Grid>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  type="submit"
                  className="btn_bg_secondery text-white"
                  variant="contained"
                  disabled={load}
                  sx={{ borderRadius: "999px", minWidth: 160 }}
                >
                  {load ? <CircularProgress size={22} color="inherit" /> : "Save Settings"}
                </Button>
              </Box>
            </Stack>
          </form>
        </Paper>
      </Box>
    </Box>
  )
}

export default Settings
